import { render, staticRenderFns } from "./SondaggioOpzioni.vue?vue&type=template&id=f84461c2&"
import script from "./SondaggioOpzioni.vue?vue&type=script&lang=js&"
export * from "./SondaggioOpzioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports